import styled from 'styled-components';
import { THEME } from '../../../themes';
import { CheckboxButtonGroupDirection } from './checkbox-button-group.enums';

export const Container = styled.div<{ direction: CheckboxButtonGroupDirection }>`
  display: flex;
  flex-direction: ${({ direction }) => direction.toLowerCase()};
  gap: ${THEME.SPACING.TINY};
`;
